"use strict";
var collapse_directive_1 = require('./collapse/collapse.directive');
exports.CollapseDirective = collapse_directive_1.CollapseDirective;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/collapse.js
 ** module id = 684
 ** module chunks = 0
 **/